<template>
  <div>
    <v-layout row wrap justify-center align-center>
      <v-flex xs11 lg11>
        <v-card class="rounded-lg pa-2">
          <v-card-title primary-title class="pa-2 ml-2 pl-4 black--text">
            รายละเอียด<v-spacer></v-spacer>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-expansion-panels v-model="panel" :disabled="disabled" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header
                  >ข้อมูล Bot Oneplatform</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <v-card rounded-lg outlined>
                    <v-layout row wrap pt-3 pa-4 class="black--text">
                      <v-flex xs11 sm11 lg11 md11>
                        <v-layout row wrap>
                          <v-flex lg12>
                            <!-- <h3 class="pb-4 black--text">ข้อมูล Bot Oneplatform</h3> -->
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap class="mt-2 mb-2">
                          <v-flex md6 lg6>
                            <b> ชื่อบอท :</b> {{ BotOnePlatform.Name ?? "-" }}
                          </v-flex>
                          <v-flex md6 lg6>
                            <!-- <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }"> -->
                            <div>
                              <b> Bot ID :</b> {{ BotOnePlatform.BotId ?? "-" }}
                              <v-icon
                                style="cursor: pointer"
                                @click="handleCopyClick(BotOnePlatform.BotId)"
                                color="#077893"
                                :key="iconState[BotOnePlatform.BotId] || 'copy'"
                                class="icon-transition"
                              >
                                {{
                                  iconState[BotOnePlatform.BotId] === "copied"
                                    ? "mdi mdi-check"
                                    : "mdi mdi-content-copy"
                                }}
                              </v-icon>
                            </div>
                            <!-- </template>
                      <span>Copy</span>
                    </v-tooltip> -->
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel v-if="GroupConsent != null">
                <v-expansion-panel-header>ข้อมูล Group Consent</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card rounded-lg outlined class="mt-4">
                    <v-layout row wrap pt-3 pa-4 class="black--text">
                      <v-flex xs11 sm11 lg11 md11>
                        <!-- <v-layout row wrap>
                    <v-flex lg12>
                      <h3 class="pb-4 black--text">ข้อมูล Group Consent</h3>
                    </v-flex>
                  </v-layout> -->
                        <v-layout row wrap>
                          <v-flex md12 lg12>
                            <b> ชื่อกลุ่ม :</b> {{ GroupConsent.Name ?? "-" }}
                          </v-flex>
                          <v-flex md12 lg12 class="mt-3 mb-3">
                            <div>
                              <b> Group ID :</b>
                              {{ GroupConsent.GroupId ?? "-" }}
                              <v-icon
                                style="cursor: pointer"
                                @click="handleCopyClick(GroupConsent.GroupId)"
                                color="#077893"
                                :key="iconState[GroupConsent.GroupId] || 'copy'"
                                class="icon-transition"
                              >
                                {{
                                  iconState[GroupConsent.GroupId] === "copied"
                                    ? "mdi mdi-check"
                                    : "mdi mdi-content-copy"
                                }}
                              </v-icon>
                            </div>
                          </v-flex>
                          <v-flex md12 lg12 class="mb-3">
                            <b> Title :</b
                            >{{
                              GroupConsent.Title == "" || null ? " -" : GroupConsent.Title
                            }}</v-flex
                          >
                          <v-flex md12 lg12>
                            <b> Tag :</b>&nbsp;
                            <v-chip
                              row
                              wrap
                              class="mr-1"
                              v-for="(tag, tagIndex) in (GroupConsent?.Tag || '')
                                .split(',')
                                .map((t) => t.trim())"
                              :key="tagIndex"
                              color="#e0f7fa"
                              variant="flat"
                            >
                              <span
                                style="color: #00695c; font-weight: bolder"
                                class="d-flex justify-center align-center w-100 h-100"
                              >
                                {{ tag }}
                              </span>
                            </v-chip>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>ข้อมูล Consent</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <!-- <v-card rounded-lg outlined class="mt-4"> -->
                  <!-- <v-layout row wrap pt-4 pl-4 pr-4>
                <v-flex lg12>
                  <h3 class="pb-4 black--text">ข้อมูล Consent</h3>
                </v-flex>
              </v-layout> -->
                  <v-layout
                    v-for="(item, index) in Consent"
                    :key="index"
                    row
                    wrap
                    pt-3
                    pa-4
                    class="black--text"
                  >
                    <v-flex xs11 sm11 lg12 md12>
                      <v-card rounded-lg outlined>
                        <v-layout row wrap pt-3 pa-4 style="width: 100%">
                          <v-flex md12 lg12>
                            <b
                              ><span v-if="Consent.length > 1">{{ index + 1 }}.</span>
                              {{ item.Title }}</b
                            >
                          </v-flex>
                          <v-flex md12 lg12 class="my-3">
                            <b> รายละเอียด :</b>
                            &nbsp;<a
                              class="text-decoration-underline cursor-pointer"
                              @click="Fn_DetailConsent(item)"
                              >{{ item.Title }}</a
                            >
                          </v-flex>
                          <v-flex md12 lg12>
                            <b> Tag : </b>
                            <v-chip
                              row
                              wrap
                              class="mr-1"
                              v-for="(tag, tagIndex) in (item.Tag || '')
                                .split(',')
                                .map((t) => t.trim())"
                              :key="tagIndex"
                              color="#ddf7ff"
                            >
                              <span
                                style="color: #077893; font-weight: bolder"
                                class="d-flex justify-center align-center w-100 h-100"
                              >
                                {{ tag }}
                              </span>
                            </v-chip>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <!-- </v-card> -->
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>ข้อมูล Policy</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card rounded-lg outlined class="mt-4">
                    <v-layout row wrap pt-3 pa-4 class="black--text">
                      <v-flex xs11 sm11 lg11 md11>
                        <!-- <v-layout row wrap>
                    <v-flex lg12>
                      <h3 class="pb-4 black--text">ข้อมูล Policy</h3>
                    </v-flex>
                  </v-layout> -->
                        <v-layout row wrap>
                          <v-flex md6 lg6>
                            <b> รายละเอียด :</b>
                            &nbsp;<a
                              @click="Fn_DetailPolicy"
                              class="text-decoration-underline cursor-pointer"
                              >{{ Policy.Title }}</a
                            >
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <div>
      <DialogBotOnePlatformConsentDetail
        :show="DialogBotOnePlatformConsentDetail"
        :_detail="GropConsentDetail"
        @closeDialogDelete="DialogBotOnePlatformConsentDetail = false"
      />
      <DialogBotOnePlatformPolicyDetail
        :show="DialogBotOnePlatformPolicyDetail"
        :_detail="Policy"
        @closeDialogDelete="DialogBotOnePlatformPolicyDetail = false"
      />
    </div>
  </div>
</template>

<script>
import DialogBotOnePlatformConsentDetail from "@/components/dialog/BotOnePlatform/DialogBotOnePlatformConsentDetail.vue";
import DialogBotOnePlatformPolicyDetail from "@/components/dialog/BotOnePlatform/DialogBotOnePlatformPolicyDetail.vue";
import authorization from "@/functions/authorization.js";
import { mapGetters } from "vuex";
export default {
  components: {
    DialogBotOnePlatformConsentDetail,
    DialogBotOnePlatformPolicyDetail,
  },
  data: () => {
    return {
      search: "",
      disabled: null,
      panel: [],
      AllService: {},
      iconState: {},
      BotOnePlatform: {},
      Policy: {},
      GroupConsent: {},
      Consent: [],
      GropConsentDetail: {},
      DialogBotOnePlatformConsentDetail: false,
      DialogBotOnePlatformPolicyDetail: false,
      tableload: false,
    };
  },
  computed: {
    ...mapGetters(["DataBotOnePlatform"]),
    _ฺBotOnePlatformAll: {
      get() {
        return this.DataBotOnePlatform || "-";
      },
    },
    _ฺBotOnePlatformID: {
      get() {
        return this.DataBotOnePlatform.Id || "-";
      },
    },
  },
  mounted() {
    this.Fn_GetDetailBotOnePlatform();
  },
  methods: {
    handleCopyClick(id) {
      // ตั้งค่าสถานะเป็น 'copied' สำหรับไอคอนนี้
      this.Fn_CopyDetail(id);
      this.$set(this.iconState, id, "copied");

      // หลังจาก 2 วินาที เปลี่ยนกลับเป็นไอคอนเดิม
      setTimeout(() => {
        this.$set(this.iconState, id, "copy");
      }, 1200);
    },
    async Fn_CopyDetail(Id) {
      await navigator.clipboard.writeText(Id);
    },
    Fn_DetailConsent(item) {
      this.GropConsentDetail = item;
      this.DialogBotOnePlatformConsentDetail = true;
    },
    Fn_DetailPolicy() {
      this.DialogBotOnePlatformPolicyDetail = true;
    },
    async Fn_GetDetailBotOnePlatform() {
      var biz_id = this.$cookies.get("BusinessId");
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var auth = await authorization.encodeDataNew(Headers);
      this.axios
        .get(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            `onechat/GroupSend/${this._ฺBotOnePlatformID}/Details`,
          {
            headers: {
              Authorization: "Bearer " + auth,
              "ngrok-skip-browser-warning": "true",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.AllService = response.data.Message;
          this.BotOnePlatform = response.data.Message.BotOnePlatform;
          this.GroupConsent = response.data.Message.GroupConsent;
          this.Policy = response.data.Message.Policy;
          this.Consent = response.data.Message.Consent;
          this.tableload = false;
          this.$emit("loaded");
        })
        .catch((error) => {
          this.$emit("loaded");
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
  },
};
</script>

<style></style>
